module.exports = __webpack_public_path__ + "img/bottom-gear-A_124x124.92762b0f.png";